<ng-container [ngSwitch]="orientation">
  <ng-container *ngSwitchCase="'horizontal'">
    <div *ngIf="mobile" class="stepper-mobile-head">
      {{ stepperMobileStepTxt }} {{ activeStepIndex + 1 }} {{ stepperMobileOfTxt }}
      {{ allStepsNumber }}
    </div>
    <ul
      class="stepper stepper-horizontal"
      [ngClass]="{
        'stepper-mobile bottom-0 position-absolute': mobile,
        'stepper-progress-bar': mobile && steps.length > mobileBarBreakpoint
      }"
    >
      <li
        [ngClass]="{
          'stepper-active': step.isActive,
          'stepper-completed': step.isCompleted,
          'stepper-invalid': step.isInvalid
        }"
        class="stepper-step"
        *ngFor="let step of steps; let i = index"
      >
        <div class="stepper-head" (click)="handleHeaderClick(i)">
          <span class="stepper-head-icon">
            <ng-container *ngIf="!step.icon">{{ i + 1 }}</ng-container>
            <ng-template [ngIf]="step.icon">
              <ng-template [cdkPortalOutlet]="step.icon"></ng-template>
            </ng-template>
          </span>
          <span
            *ngIf="!step.header"
            class="stepper-head-text"
            [attr.data-mdb-content]="step.optional ? step.optionalText : null"
            >{{ step.name }}</span
          >
          <span *ngIf="step.header" class="stepper-head-text">
            <ng-template [ngIf]="step.header">
              <ng-template [cdkPortalOutlet]="step.header"></ng-template>
            </ng-template>
          </span>
        </div>
      </li>
    </ul>
    <div class="stepper-horizontal-content-container">
      <ng-container *ngFor="let step of steps; let i = index">
        <div
          class="stepper-content"
          [attr.aria-expanded]="activeStepIndex === i"
          [@horizontalAnimation]="getAnimationState(i)"
        >
          <ng-container [ngTemplateOutlet]="step.content"></ng-container>
        </div>
      </ng-container>
    </div>
    <div *ngIf="mobile" class="stepper-mobile-footer">
      <div class="stepper-back-btn">
        <button (click)="previous()" type="button" class="btn btn-link">
          <i class="fas fa-chevron-left"></i>{{ stepperMobileBackBtn }}
        </button>
      </div>
      <div *ngIf="steps.length > mobileBarBreakpoint" class="stepper-mobile-progress gray-500">
        <div class="stepper-mobile-progress-bar" [style.width.%]="getProgressBarWidth()"></div>
      </div>
      <div class="stepper-next-btn">
        <button (click)="next()" type="button" class="btn btn-link">
          {{ stepperMobileNextBtn }}<i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'vertical'">
    <ul class="stepper stepper-vertical">
      <li
        [ngClass]="{
          'stepper-active': step.isActive,
          'stepper-completed': step.isCompleted,
          'stepper-invalid': step.isInvalid
        }"
        class="stepper-step"
        *ngFor="let step of steps; let i = index"
      >
        <div class="stepper-head" (click)="handleHeaderClick(i)">
          <span class="stepper-head-icon">
            <ng-container *ngIf="!step.icon">{{ i + 1 }}</ng-container>
            <ng-template [ngIf]="step.icon">
              <ng-template [cdkPortalOutlet]="step.icon"></ng-template>
            </ng-template>
          </span>
          <span
            class="stepper-head-text"
            [attr.data-mdb-content]="step.optional ? step.optionalText : null"
          >
            <ng-container *ngIf="!step.header">{{ step.name }}</ng-container>
            <ng-template [ngIf]="step.header">
              <ng-template [cdkPortalOutlet]="step.header"></ng-template>
            </ng-template>
          </span>
        </div>
        <div class="stepper-vertical-content-container" [@verticalAnimation]="getAnimationState(i)">
          <div class="stepper-content">
            <ng-container [ngTemplateOutlet]="step.content"></ng-container>
          </div>
        </div>
      </li>
    </ul>
  </ng-container>
</ng-container>
